import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Tooltip } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { getBrandConfig } from '../../brands/brand-registry';
import UserProfile from "../UserProfile/UserProfile";
import { useUserContext } from '../UserContext/UserContext';
import './Navigation.css';

interface NavigationProps {
  onMenuClick?: () => void;
}

const Navigation: React.FC<NavigationProps> = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const { userProfile } = useUserContext();

  // Get brand configuration
  const brandId = import.meta.env.VITE_BRAND_ID;
  if (!brandId) {
    throw new Error('VITE_BRAND_ID environment variable is required');
  }
  const brandConfig = getBrandConfig(brandId);

  return (
    <header className="admin-header">
      {/* Left section - Mobile menu toggle & breadcrumb area */}
      <div className="header-left">
        {userProfile && onMenuClick && (
          <Tooltip title="Toggle menu">
            <Button 
              type="text" 
              icon={<MenuOutlined />} 
              onClick={onMenuClick}
              className="mobile-menu-toggle"
            />
          </Tooltip>
        )}
        <span className="header-title">{brandConfig.appName}</span>
      </div>
      
      {/* Right section - User Profile */}
      <div className="header-right">
        <UserProfile />
      </div>
    </header>
  );
};

export default Navigation;

